import { render, staticRenderFns } from "./ButtonRippleEffect.vue?vue&type=template&id=3bcf2e28"
import script from "./ButtonRippleEffect.vue?vue&type=script&lang=js"
export * from "./ButtonRippleEffect.vue?vue&type=script&lang=js"
import style0 from "./ButtonRippleEffect.vue?vue&type=style&index=0&id=3bcf2e28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports